// PageNumberPagination on /api3/agents/list/ is fixed at 20.
export const AGENTS_PAGE_SIZE = 20;

const initialState = {
  listStatus: 'idle',
  error: null,
  requestIds: { list: null, more: null, refresh: null },
  pageSize: AGENTS_PAGE_SIZE,
  page: 0,
  loadingMore: false,
  loadMoreFailed: false,
  reachedEnd: false,
  count: 0,
  availableAgents: null,
  totalActive: null,
  totalActiveFiltered: null,
  totalInactiveFiltered: null,
  agents: [],
  branches: [],
  branchesCount: 0,
  branchesStatus: 'idle',
  teams: [],
  teamsStatus: 'idle',
};

export default initialState;
